import { jsx as _jsx } from "react/jsx-runtime";
import noop from "lodash/noop";
import { createContext, useCallback, useContext, useMemo, useRef } from "react";
import { useResizeDetector } from "react-resize-detector";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
const defaultContextValue = {
    assetModalRef: {
        current: null
    },
    navigationHeight: undefined,
    // @ts-ignore
    navigationRef: {
        current: null
    },
    panelRef: {
        current: null
    },
    scrollToBottom: noop,
    scrollToPanel: noop,
    scrollToTop: noop
};
export const MobileAssetModalContext = /*#__PURE__*/ createContext(defaultContextValue);
export const MobileAssetModalContextProvider = (param)=>{
    let { children, stickOnTop } = param;
    const assetModalRef = useRef(null);
    const panelRef = useRef(null);
    const { height: navigationHeight, ref: navigationRef } = useResizeDetector();
    const scrollToPanel = useCallback(()=>{
        const scrollTo = ()=>{
            var _panelRef_current, _assetModalRef_current;
            const top = ((_panelRef_current = panelRef.current) === null || _panelRef_current === void 0 ? void 0 : _panelRef_current.offsetTop) && navigationHeight ? panelRef.current.offsetTop - navigationHeight : 0;
            (_assetModalRef_current = assetModalRef.current) === null || _assetModalRef_current === void 0 ? void 0 : _assetModalRef_current.scrollTo({
                top,
                behavior: "smooth"
            });
        };
        setTimeout(scrollTo, 100);
    }, [
        navigationHeight
    ]);
    const scrollToTop = useCallback(()=>{
        var _assetModalRef_current;
        (_assetModalRef_current = assetModalRef.current) === null || _assetModalRef_current === void 0 ? void 0 : _assetModalRef_current.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    const scrollToBottom = useCallback(()=>{
        const scrollTo = ()=>{
            var _assetModalRef_current;
            return (_assetModalRef_current = assetModalRef.current) === null || _assetModalRef_current === void 0 ? void 0 : _assetModalRef_current.scrollTo({
                top: assetModalRef.current.scrollHeight,
                behavior: "smooth"
            });
        };
        setTimeout(scrollTo, 100);
    }, []);
    const value = useMemo(()=>({
            assetModalRef,
            navigationHeight: stickOnTop ? 0 : navigationHeight,
            navigationRef,
            panelRef,
            scrollToBottom,
            scrollToPanel,
            scrollToTop
        }), [
        navigationHeight,
        navigationRef,
        scrollToBottom,
        scrollToPanel,
        scrollToTop,
        stickOnTop
    ]);
    return /*#__PURE__*/ _jsx(MobileAssetModalContext.Provider, {
        value: value,
        children: children
    });
};
export const useMobileAssetModalContext = ()=>{
    const context = useContext(MobileAssetModalContext);
    if (context === defaultContextValue) {
        const error = "useMobileAssetModalContext must be used within a MobileAssetModalContextProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
